<div class="summary">
  <div class="summary__header" *ngIf="!hideTitle">
    <span>{{title}}</span>
  </div>
  <div class="summary__block">
    <ng-content></ng-content>
  </div>

  <ng-content select="[footer]"></ng-content>

  <div>
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>
